import type { ISPPlanType, ISPPlanDetail } from '@/api/rxjs/knst/ISPForm/models/get_plans.model'

export class ISPTypeForm {
  planType: ISPPlanType | null
  planDetail: ISPPlanDetail | null
  constructor() {
    this.planType = null
    this.planDetail = null
  }
}